import { render } from "./QuotePriceList.vue?vue&type=template&id=dba3a47c"
import script from "./QuotePriceList.vue?vue&type=script&lang=js"
export * from "./QuotePriceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__